<template>
  <div id="header">

  </div>
</template>

<script>

export default {
  name: 'Header',
  data() {
    return {
    };
  },
  created() {
  },
  computed: {
  }
};
</script>
<style lang="scss">
@import "./../assets/scss/main.scss";

#header {
  height: $headerHeight;
  background-color: #757575;
}

</style>
